import { t as gsapWithCSS } from "@theme/gsap";
import { r as refreshScrollTrigger } from "@theme/gsap-utils";
//#region frontend/islands/expandable-science-accordion.js
var ExpandableScienceAccordion = class extends window.HTMLElement {
	connectedCallback() {
		this.button = this.querySelector("button");
		this.content = this.querySelector("[data-accordion-content=\"true\"]");
		this.expandIcon = this.querySelector(".expand-science-accordion");
		this.collapseIcon = this.querySelector(".collapse-science-accordion");
		this._version = 0;
		if (this.button && this.content) {
			this.button.addEventListener("click", () => this.toggle());
			this.initializeHeight();
		}
	}
	initializeHeight() {
		if (this.button.getAttribute("aria-expanded") === "true") {
			this.content.style.height = "auto";
			this.content.style.overflow = "visible";
		} else {
			this.content.style.height = "0px";
			this.content.style.overflow = "hidden";
		}
	}
	toggle() {
		if (this.button.getAttribute("aria-expanded") === "true") this.close();
		else this.open();
	}
	open() {
		const version = ++this._version;
		this.button.setAttribute("aria-expanded", "true");
		this.content.style.overflow = "hidden";
		gsapWithCSS.to(this.content, {
			height: this.content.scrollHeight,
			duration: .6,
			ease: "power3.out",
			overwrite: "auto",
			onComplete: () => {
				if (version !== this._version) return;
				this.content.style.height = "auto";
				this.content.style.overflow = "visible";
				refreshScrollTrigger();
			}
		});
		gsapWithCSS.to(this.expandIcon, { opacity: 0 });
		gsapWithCSS.to(this.collapseIcon, { opacity: 1 });
	}
	close() {
		const version = ++this._version;
		this.button.setAttribute("aria-expanded", "false");
		this.content.style.overflow = "hidden";
		gsapWithCSS.to(this.content, {
			height: 0,
			duration: .6,
			ease: "power3.out",
			overwrite: "auto",
			onComplete: () => {
				if (version !== this._version) return;
				refreshScrollTrigger();
			}
		});
		gsapWithCSS.to(this.expandIcon, { opacity: 1 });
		gsapWithCSS.to(this.collapseIcon, { opacity: 0 });
	}
};
window.customElements.define("expandable-science-accordion", ExpandableScienceAccordion);
//#endregion
